package ai.wagemix.pages

import ai.wagemix.di.koin
import ai.wagemix.env
import ai.wagemix.logic.WMNavigationRequest
import ai.wagemix.navigate
import ai.wagemix.siteStrings
import ai.wagemix.web.screens.account.WMAccountScreen
import ai.wagemix.web.screens.account.WMDefaultAccountWebViewModel
import ai.wagemix.web.screens.jobdescriptions.WMDefaultJobDescriptionsWebViewModel
import ai.wagemix.web.screens.jobdescriptions.WMJobDescriptionsScreen
import ai.wagemix.web.screens.mixes.WMDefaultSavedMixesWebViewModel
import ai.wagemix.web.screens.mixes.WMSavedMixesScreen
import ai.wagemix.web.screens.payment.WMDefaultPaymentResultWebViewModel
import ai.wagemix.web.screens.payment.WMPaymentResultScreen
import ai.wagemix.web.screens.share.WMDefaultShareMixWebViewModel
import ai.wagemix.web.screens.share.WMShareMixDialog
import ai.wagemix.web.screens.sharedlinks.WMDefaultSharedLinksWebViewModel
import ai.wagemix.web.screens.sharedlinks.WMSharedLinksScreen
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import org.koin.core.parameter.parametersOf

@Page(routeOverride = "/mixes")
@Layout(".components.layouts.AppShellLayout")
@Composable
fun MixesPage(ctx: PageContext) {
    val s = siteStrings
    val nav = { request: WMNavigationRequest -> ctx.navigate(request) }
    var shareMixId by remember { mutableStateOf<String?>(null) }
    WMSavedMixesScreen(
        createViewModel = { koin.get<WMDefaultSavedMixesWebViewModel> { parametersOf(nav, { mixId: String -> shareMixId = mixId }) } },
        strings = s
    )
    shareMixId?.let { id ->
        WMShareMixDialog(
            createViewModel = { koin.get<WMDefaultShareMixWebViewModel> { parametersOf(id, nav) } },
            mixId = id,
            strings = s,
            onClose = { shareMixId = null }
        )
    }
}

@Page(routeOverride = "/job-descriptions")
@Layout(".components.layouts.AppShellLayout")
@Composable
fun JobDescriptionsPage(ctx: PageContext) {
    WMJobDescriptionsScreen(
        createViewModel = { koin.get<WMDefaultJobDescriptionsWebViewModel> { parametersOf({ request: WMNavigationRequest -> ctx.navigate(request) }) } },
        strings = siteStrings
    )
}

@Page(routeOverride = "/account")
@Layout(".components.layouts.AppShellLayout")
@Composable
fun AccountPage(ctx: PageContext) {
    WMAccountScreen(
        createViewModel = { koin.get<WMDefaultAccountWebViewModel> { parametersOf({ request: WMNavigationRequest -> ctx.navigate(request) }) } },
        strings = siteStrings,
    )
}

@Page(routeOverride = "/payment-result")
@Layout(".components.layouts.AppShellLayout")
@Composable
fun PaymentResultPage(ctx: PageContext) {
    val sessionId = ctx.route.params["session_id"]
    WMPaymentResultScreen(
        createViewModel = { koin.get<WMDefaultPaymentResultWebViewModel> { parametersOf(sessionId ?: "") } },
        sessionId = sessionId,
        strings = siteStrings
    )
}

@Page(routeOverride = "/shared-links")
@Layout(".components.layouts.AppShellLayout")
@Composable
fun SharedLinksPage(ctx: PageContext) {
    WMSharedLinksScreen(
        createViewModel = { koin.get<WMDefaultSharedLinksWebViewModel>() },
        strings = siteStrings
    )
}
